(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/pages/login/player-login.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/pages/login/player-login.js');

'use strict';

const {
  useHistory
} = ReactRouterDOM;
const {
  loginType,
  route
} = svs.playerLogin.constants;
const PlayerLogin = _ref => {
  let {
    isBankId,
    isHome = false
  } = _ref;
  const history = useHistory();
  const lastPlayerLoginType = ReactRedux.useSelector(state => state.playerloginreact.lastPlayerLoginType);
  const isCustomerRegistration = ReactRedux.useSelector(state => state.playerloginreact.isCustomerRegistration);
  React.useEffect(() => {
    if (isCustomerRegistration) {
      history.push(route.REGISTRATE_HOME_ROUTE);
    } else if (isHome && lastPlayerLoginType === loginType.BANKID || !isHome && isBankId) {
      history.push(route.LOGIN_BANKID_START_ROUTE);
    } else {
      history.push(route.LOGIN_FREJAEID_START_ROUTE);
    }
  }, []);
  return null;
};
PlayerLogin.propTypes = {
  isBankId: PropTypes.bool.isRequired,
  isHome: PropTypes.bool
};
svs.playerLogin.login.PlayerLogin = PlayerLogin;

 })(window);